/**
 * Shared customer display helpers for External Costs module.
 */

export const WECLAPP_PARTY_BASE_URL = 'https://unternehmenonline.weclapp.com/app/party/';

/** Format customer label for dropdown options: "Name (A1234)" */
export function customerLabel(customer) {
    if (!customer) return '';
    const num = customer.customer_number;
    return num ? `${customer.title} (${num})` : customer.title;
}

/** Build WeClapp party URL from customer weclapp_customer_id */
export function weclappCustomerUrl(customer) {
    const id = customer?.weclapp_customer_id;
    return id ? `${WECLAPP_PARTY_BASE_URL}${id}` : null;
}
